export function DailySalesNotes() {
  return (
    <section className="nb-card nb-ds-notes" aria-labelledby="daily-sales-notes">
      <h3 id="daily-sales-notes" className="nb-display" style={{ fontSize: 13, margin: 0 }}>
        How the numbers are counted
      </h3>
      <p>
        Each sale is counted on the day it was made (Eastern time) and stays there, even if the
        booking is later cancelled, refunded or moved to another date. This matches
        FareHarbor&apos;s Daily Sales report with &ldquo;Report on: Transaction date&rdquo;.
      </p>
      <p>
        <b>FareHarbor</b> comes from the data warehouse: every original booking except private
        events, which are left out. Moving a booking to a new date doesn&apos;t count as a new sale.
        Gross payment includes tax and fees; pre-tax is the receipt subtotal.
      </p>
      <p>
        <b>Gift cards</b> are FareHarbor gift card purchases. <b>Gift passes</b> are gift passes
        bought in Nebari: each purchase is one order, and passes counts how many it held. Gross
        payment is what the buyer paid; a booking later paid for with a pass adds only the cash it
        took, so the pass is never counted twice.
      </p>
      <p>
        <b>Nebari</b> comes from the Nebari app: every order placed, whatever its status now,
        excluding comps and rebookings. Gross payment includes tax and fees; pre-tax is the order
        subtotal.
      </p>
      <p>
        <b>Retail</b> is Shopify product orders: <b>in store</b> is what was rung up at a workshop,{' '}
        <b>online</b> is the online store. Orders that held a workshop ticket or gift card are left
        out, and online orders count from February 1, 2026, when the online store stopped selling
        tickets. Gross payment includes tax and shipping; pre-tax is the order subtotal. Items are
        the number of products sold.
      </p>
      <p>
        <b>Regions</b> follow the workshop a ticket was bought for, and a region includes the
        regions inside it. FareHarbor sales find their region through the Nebari workshop they were
        imported as. Gift cards, gift passes and retail aren&apos;t tied to a workshop, so they
        belong to no region.
      </p>
      <p>
        Today&apos;s numbers are partial and shown lighter. The warehouse copy of FareHarbor
        bookings refreshes through the day, so today&apos;s FareHarbor numbers trail Nebari&apos;s.
      </p>
    </section>
  );
}
